import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_OMPLIR_ESPECIE_FENOFASE_SELECCIONADA
} from "../../actions/actionTypes";

const ESTAT_INICIAL = {};

const especieFenofaseSeleccionada = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case VISUALITZACIO_OMPLIR_ESPECIE_FENOFASE_SELECCIONADA:
      return action.payload;

    default:
      return state;
  }
};

export default especieFenofaseSeleccionada;

export const getEspecieFenofaseSeleccionada = state =>
  state.especieFenofaseSeleccionada;
